import React, { useState } from 'react';
import { Menu, X, User, LogOut, Shield } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { cn } from '../lib/utils';
import { useAuth } from '../hooks/useAuth';
interface NavbarProps {
  onNavigate: (page: string) => void;
}
export function Navbar({
  onNavigate
}: NavbarProps) {
  const [isOpen, setIsOpen] = useState(false);
  const {
    isAuthenticated,
    user,
    signOut
  } = useAuth();
  const isAdmin = user?.email === 'earivassb@gmail.com';
  const navLinks = [{
    name: 'Inicio',
    href: '#'
  }, {
    name: 'Proceso',
    href: '#process'
  }, {
    name: 'Costos',
    href: '#costs'
  }, {
    name: 'Servicios',
    href: '#services'
  }, {
    name: 'Sobre Nosotros',
    href: '#mission'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-earia-bg/90 backdrop-blur-md border-b border-earia-border" data-id="element-272">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-273">
        <div className="flex items-center justify-between h-16" data-id="element-274">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2" data-id="element-275">
            <div className="w-10 h-8 bg-earia-accent rounded-lg flex items-center justify-center shadow-sm" data-id="element-276">
              <span className="text-earia-text-heading font-bold tracking-tight text-[18px]" data-id="element-277">
                EAR
              </span>
            </div>
            <span className="text-earia-text-heading font-bold tracking-tight text-[16px]" data-id="element-278">
              Import{' '}
              <span style={{
              color: '#d42323'
            }} data-id="element-279">
                Auto
              </span>
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:block" data-id="element-280">
            <div className="ml-10 flex items-baseline space-x-8" data-id="element-281">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-earia-text-body hover:text-earia-accent px-3 py-2 rounded-md text-sm font-medium transition-colors" data-id="element-282">
                  {link.name}
                </a>)}
            </div>
          </div>

          {/* CTA Button */}
          <div className="hidden md:flex items-center gap-3" data-id="element-283">
            {isAuthenticated ? <>
                {isAdmin && <button onClick={() => onNavigate('admin')} className="text-earia-text-body hover:text-blue-600 font-medium text-sm px-3 py-2 transition-colors flex items-center gap-1.5" data-id="element-284">
                    <Shield className="w-4 h-4" data-id="element-285" />
                    Admin
                  </button>}
                <button onClick={() => onNavigate('my-cars')} className="text-earia-text-body hover:text-earia-accent font-medium text-sm px-3 py-2 transition-colors flex items-center gap-1.5" data-id="element-286">
                  <User className="w-4 h-4" data-id="element-287" />
                  Mis Solicitudes
                </button>
                <button onClick={async () => {
              await signOut();
              onNavigate('home');
            }} className="text-gray-400 hover:text-red-500 text-sm px-2 py-2 transition-colors" title="Cerrar sesión" data-id="element-288">
                  <LogOut className="w-4 h-4" data-id="element-289" />
                </button>
              </> : <button onClick={() => onNavigate('auth')} className="text-earia-text-body hover:text-earia-accent font-medium text-sm px-3 py-2 transition-colors flex items-center gap-1.5" data-id="element-290">
                <User className="w-4 h-4" data-id="element-291" />
                Iniciar Sesión
              </button>}
            <button onClick={() => onNavigate('car-finder')} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-md text-sm transition-colors shadow-sm" data-id="element-292">
              Tu Carro Ideal
            </button>
            <a href="#cta" className="bg-earia-accent hover:bg-earia-accent-hover text-earia-text-heading font-bold py-2 px-4 rounded-md text-sm transition-colors shadow-sm" data-id="element-293">
              Obtén tu Cotización
            </a>
          </div>

          {/* Mobile menu button */}
          <div className="-mr-2 flex md:hidden" data-id="element-294">
            <button onClick={() => setIsOpen(!isOpen)} className="inline-flex items-center justify-center p-2 rounded-md text-earia-text-body hover:text-earia-text-heading hover:bg-earia-bg-alt focus:outline-none" data-id="element-295">
              <span className="sr-only" data-id="element-296">Open main menu</span>
              {isOpen ? <X className="block h-6 w-6" data-id="element-297" /> : <Menu className="block h-6 w-6" data-id="element-298" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-299">
        {isOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-earia-bg border-b border-earia-border" data-id="element-300">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-301">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="text-earia-text-body hover:text-earia-accent block px-3 py-2 rounded-md text-base font-medium" data-id="element-302">
                  {link.name}
                </a>)}

              {isAuthenticated ? <>
                  {isAdmin && <button onClick={() => {
              setIsOpen(false);
              onNavigate('admin');
            }} className="text-earia-text-body hover:text-blue-600 block w-full text-left px-3 py-2 rounded-md text-base font-medium flex items-center gap-2" data-id="element-303">
                      <Shield className="w-4 h-4" data-id="element-304" />
                      Panel Admin
                    </button>}
                  <button onClick={() => {
              setIsOpen(false);
              onNavigate('my-cars');
            }} className="text-earia-text-body hover:text-earia-accent block w-full text-left px-3 py-2 rounded-md text-base font-medium" data-id="element-305">
                    Mis Solicitudes
                  </button>
                  <button onClick={async () => {
              setIsOpen(false);
              await signOut();
              onNavigate('home');
            }} className="text-gray-400 hover:text-red-500 block w-full text-left px-3 py-2 rounded-md text-base font-medium" data-id="element-306">
                    Cerrar Sesión
                  </button>
                </> : <button onClick={() => {
            setIsOpen(false);
            onNavigate('auth');
          }} className="text-earia-text-body hover:text-earia-accent block w-full text-left px-3 py-2 rounded-md text-base font-medium" data-id="element-307">
                  Iniciar Sesión
                </button>}

              <button onClick={() => {
            setIsOpen(false);
            onNavigate('car-finder');
          }} className="w-full bg-blue-600 text-white block px-3 py-2 rounded-md text-base font-bold mt-4 text-center" data-id="element-308">
                Tu Carro Ideal
              </button>
              <a href="#cta" onClick={() => setIsOpen(false)} className="bg-earia-accent text-earia-text-heading block px-3 py-2 rounded-md text-base font-bold mt-2 text-center" data-id="element-309">
                Cotizar Ahora
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}